export enum MoveDirection
{
  Backward = -1,
  Forward  = 1,
}

export enum Orientation
{
  Horizontal = 0,
  Vertical = 1,
}